<!-- Button -->
<button *ngIf="usuario.tipo == 'Apostador'" (click)="deposito()" class="font-bold mr-2 bg-green p-2" mat-button>
	Depósito
</button>
<button class="icon-button" mat-icon-button [matMenuTriggerFor]="userActions">
	<span class="avatar">
		<mat-icon [svgIcon]="'mat_outline:person'"></mat-icon>
	</span>
</button>

<mat-menu class="user-actions-menu" [xPosition]="'before'" #userActions="matMenu">
	<button mat-menu-item>
		<span class="user-info">
			<span>{{ usuario.nome }}</span>
			<span class="email">{{ usuario.tipo }}</span>
		</span>
	</button>
	<mat-divider class="my-2"></mat-divider>
	<!-- <button mat-menu-item>
        <mat-icon [svgIcon]="'account_circle'"></mat-icon>
        <span>Profile</span>
    </button> -->

	<!-- <button mat-menu-item
            [matMenuTriggerFor]="temaMenu">
        <mat-icon [svgIcon]="'radio_button_unchecked'"></mat-icon>
        <span>Tema</span>
    </button> -->

	<!-- <mat-divider class="my-2"></mat-divider> -->
	<!-- <button mat-menu-item *ngIf="usuario.tipo == 'Vendedor' || usuario.tipo == 'Gerente'" (click)="compartilhar()">
        <mat-icon [svgIcon]="'share'"></mat-icon>
        <span>Compartilhar link</span>
    </button> -->

	<button *ngIf="isWebView" mat-menu-item (click)="ajustes()">
		<mat-icon [svgIcon]="'settings'"></mat-icon>
		<span>Ajustes</span>
	</button>

	<div mat-menu-item *ngIf="usuario.tipo == 'Apostador'">
		<span class="email"
			>Saldo: <b>{{numeroParaReal(usuario.limite_simples)}}</b></span
		>
	</div>

	<button *ngIf="usuario.tipo != 'Cliente'" mat-menu-item (click)="alterarSenha()">
		<mat-icon [svgIcon]="'mat_outline:lock'"></mat-icon>
		<span>Alterar senha</span>
	</button>

	<button mat-menu-item (click)="baixarApp()">
		<mat-icon [svgIcon]="'huge:Download01Icon'"></mat-icon>
		<span>Baixar APP</span>
	</button>
	<button mat-menu-item (click)="signOut()">
		<mat-icon [svgIcon]="'power_settings_new'"></mat-icon>
		<span>Sair</span>
	</button>
</mat-menu>

<!-- <mat-menu class="user-status-menu"
          #temaMenu="matMenu">
    <button mat-menu-item
            (click)="setTema('light')">
        <span class="status online"></span>
        <span>Claro</span>
    </button>
    <button mat-menu-item
            (click)="setTema('dark')">
        <span class="status away"></span>
        <span>Escuro</span>
    </button>

</mat-menu> -->
